import { env } from "../config/env";

function apiBaseUrl(): string {
  return String(
    env.apiUrl
  ).replace(
    /\/$/,
    ""
  );
}

export function categoryImageUrl(
  categoryId: string
): string {
  return `${apiBaseUrl()}/media/category-images/${categoryId}`;
}
